// extracted by mini-css-extract-plugin
module.exports = {"title":"TitledIcons_title__Mak0u"};